import type { CustomFile } from '../types';

import getRelativePathData from './getRelativePathData';

// ----------------------------------------------------------------------------

export type TypeGroupedFilesResult = Record<string, Record<string, { files: CustomFile[]; totalSize: number }>>;

// ----------------------------------------------------------------------------

function groupFilesByRootFolder(files: CustomFile[]): TypeGroupedFilesResult {
    const groupedFiles: TypeGroupedFilesResult = {};

    for (const file of files) {
        const pathData = getRelativePathData(file);

        if (pathData?.rootFolder == null) {
            continue;
        }
        const { rootFolder } = pathData;
        const dirPath = pathData.dirPath ?? rootFolder;

        if (!groupedFiles[rootFolder]) {
            groupedFiles[rootFolder] = {};
        }

        if (!groupedFiles[rootFolder][dirPath]) {
            groupedFiles[rootFolder][dirPath] = { files: [], totalSize: 0 };
        }

        groupedFiles[rootFolder][dirPath].files.push(file);
        groupedFiles[rootFolder][dirPath].totalSize += file.size;
    }

    return groupedFiles;
}

// ----------------------------------------------------------------------------

export default groupFilesByRootFolder;
